import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

export default function BlockedReason({ returnBack }) {
  return (
    <Modal
      header={
        <h3>We Can&apos;t Schedule This Session...Yet!</h3>
      }
      size="lg"
      show
      onHide={returnBack}
    >
      <p>
        Your account is currently blocked, so this session cannot be scheduled at the moment.
        Please contact the LeggUP Support Team for further assistance.
      </p>

      <footer className="d-flex justify-content-end">
        <div>
          <Button onClick={returnBack}>Ok</Button>
        </div>
      </footer>

    </Modal>
  );
}

BlockedReason.propTypes = {
  returnBack: PropTypes.func,
};

BlockedReason.defaultProps = {
  returnBack: () => {},
};
